// extracted by mini-css-extract-plugin
export default {"blocks":"MediaBlock-module--blocks--ptBsA","block":"MediaBlock-module--block--TcSA1","copyBlock":"MediaBlock-module--copyBlock--rs2hE"};